import SiteFooter from "./SiteFooter";
import SiteHeader from "./SiteHeader";
import { useState } from "react";
import { doAccountReset, getURL } from "./client";
import { MailOutlined } from "@ant-design/icons";
import { Form, Input, Button, Result } from "antd";
import { Link } from "react-router-dom";

const ForgotPasswordPage = (props) => {
  const [isCompleted, setIsCompleted] = useState(false);
  const onFinish = (values) => {
    props.setSpin(true);
    doAccountReset({ email: values.email })
      .then((res) => res.json())
      .then((data) => {})
      .finally((func) => {
        setIsCompleted(true);
        props.setSpin(false);
      });
  };
  return (
    <>
      <SiteHeader headerType="create-account" />
      <div className="sign-in-intro">
        {!isCompleted && (
          <>
            <h3>Reset Account Password</h3>
            <p>
              To reset your password, enter the email address linked to your
              account.
            </p>
            <Form
              name="normal_login"
              className="login-form"
              onFinish={onFinish}
            >
              <Form.Item
                name="email"
                rules={[
                  {
                    type: "email",
                    message: "The input is not valid E-mail!",
                  },
                  {
                    required: true,
                    message: "Please input your E-mail!",
                  },
                ]}
              >
                <Input
                  prefix={<MailOutlined className="site-form-item-icon" />}
                  placeholder="Email address"
                />
              </Form.Item>
              <Form.Item>
                <Button
                  block
                  type="primary"
                  htmlType="submit"
                  className="login-form-button"
                >
                  Request Password Reset
                </Button>
              </Form.Item>
              <Link to={getURL("/")}>
                <Button block type="default" className="login-form-button">
                  Back to Sign In
                </Button>
              </Link>
            </Form>
          </>
        )}
        {isCompleted && (
          <Result
            status="success"
            title="Password Recovery Email Sent"
            subTitle="If an account with the email address exists, you will receive an email with instructions on how to reset your password."
            extra={[
              <Link key="recovery-sign-in" to={getURL("/")}>
                <Button type="default" className="login-form-button">
                  Sign in
                </Button>
              </Link>,
            ]}
          />
        )}
      </div>
      <SiteFooter />
    </>
  );
};
export default ForgotPasswordPage;
